const CheckIcon = () => {
  return (
<svg viewBox="0 0 24 24" height={16} width={16} fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>  
)
}

export default CheckIcon